module.exports = __webpack_public_path__ + "static/media/analytics.bf535b28.svg";